import React from "react";
import cntImg from "../assets/images/cnt.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Star from "../assets/icons/Star";
import client from '../assets/images/client.png';
import { t } from "i18next";

const testimonials = [
  {
    name: "David Erhicon",
    role: "Restaurant Owner",
    rating: 5,
    testimonial:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    img: client,
  },
  {
    name: "Emily Johnson",
    role: "Restaurant Manager",
    rating: 4,
    testimonial:
      "Aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex.",
    img: client,
  },
  {
    name: "John Doe",
    role: "Chef",
    rating: 5,
    testimonial:
      "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam.",
    img: client,
  },
];

const ClientTestimonial = () => {
  return ;
  return (
    <section className="client_testimonial_section">
      <div className="wrapper">
        <div className="client_main_grid">
          <div className="cnt_fximage">
            <img src={cntImg} alt="Why Restaurants Love Working with Us" />
          </div>
          <div className="cnt_content">
            <h2 className="subtitle_common">
              {t("why_restaurants")}{" "}
              <span className="text-primary">{t("love_working_with_us")}</span>
            </h2>
            <div className="cnt_slider">
              <Swiper
                pagination={{ clickable: true }}
                loop={true}
                spaceBetween={10}
                autoplay={{ delay: 2500 }}
                modules={[Pagination, Autoplay]}
                className="mySwiper"
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <div className="testimonial_slide">
                      <p className="test_name">{testimonial.name}</p>
                      <p className="test_role">{testimonial.role}</p>
                      <div className="rating">
                        {Array(testimonial.rating)
                          .fill()
                          .map((_, i) => (
                            <Star key={i} />
                          ))}
                      </div>
                      <p className="testimonial_text">
                        {testimonial.testimonial}
                      </p>
                      <div className="test_img">
                        <img src={testimonial.img} alt={testimonial.name} />
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientTestimonial;
